export default "__VITE_ASSET__a7c3df30__"